module.exports = __webpack_public_path__ + "static/media/blazer_right_img.1020899b.png";